export const brazilLabel = {
  "Enter_the_following_information_to_enter": "Insira as informações a seguir para entrar",
  "login": "login",
  "Username": "Nome de usuário",
  "password": "Senha",
  "Orders": "Pedidos",
  "Online": "Online",
  "Offline": "Offline",
  "Info": "Informações",
  "email": "Email",
  "vehicletypes": "tiposdeserviço",
  "loginstatus": "status de login",
  "lastonlinetime": "última vez online",
  "fetchingdata": "Recebendo informações...",
  "poperLoading": "por favor, aguarde",
  "Noinformationfound": "Nenhuma informação encontrada",
  "Drivers": "Motoristas",
  "otherdropoffs": "outros destinos",
  "paymentmethod": "Método de pagamento",
  "Receiver": "Pelo destinatário",
  "Sender": "Pelo remetente",
  "Balance": "Saldo",
  "Cash": "Dinheiro",
  "Wallet": "Carteira",
  "Close": "Fechar",
  "noVehicleType": "Não há tipo de serviço para mostrar",
  "Fname": "Nome",
  "Lname": "Sobrenome",
  "Pnumber": "Número de telefone",
  "driver": "Motorista",
  "Pleasetryanotherkeyword": "Por favor, tente outra palavra-chave",
  "Încearcă alt cuvânt cheie": "Intente otra clave",
  "DropOff": "Entrega",
  "Noaddressavailable": "Nenhum endereço disponível",
  "Managefavoriteaddresses": "Gerenciar endereços",
  "address": "Endereço",
  "Saved": "Salvo",
  "block": "Bloco",
  "Floor": "Andar",
  "Unit": "Unidade",
  "Recieverfullname": "Nome do destinatário",
  "Recieverphonenumber": "Número do destinatário",
  "notesfordriver": "Notas para o motorista",
  "Price": "Preço",
  "EditOrder": "Editar pedido",
  "Firstname": "Nome",
  "Lastname": "Sobrenome",
  "Phonenumber": "Número de telefone",
  "senderfullname": "Nome do remetente",
  "senderphonenumber": "Número do remetente",
  "Search": "Pesquisar",
  "Service": "Serviço",
  "Passenger": "Cliente",
  "Pickup": "Coleta",
  "Pricedetails": "Detalhes do preço",
  "Fee": "Taxa",
  "Fornow": "Por enquanto",
  "Scheduled": "Agendado",
  "before": "antes:",
  "Settime": "Definir horário",
  "after": "após:",
  "confirm": "Confirmar",
  "Cancel": "Cancelar",
  "Addresses": "Endereços",
  "Savedaddresses": "Endereços salvos",
  "new": "Novo",
  "Editaddress": "Editar endereço",
  "Saveaddress": "Salvar endereço",
  "Language": "Idioma",
  "en": "Inglês",
  "fa": "Persa",
  "English": "Inglês",
  "Persian": "Persa",
  "Logout": "Sair",
  "logotTitle": "Sair da conta?",
  "logoutDescription": "Você será desconectado da conta e deverá fazer login novamente mais tarde",
  "confirmLogout": "Sim, sair",
  "skipLogout": "Cancelar",
  "Ascending": "Ascendente",
  "Descending": "Descendente",
  "sort[createdAt]": "Data",
  "sort[pickupScheduleDate]": "Horário agendado de coleta",
  "sort[statusUpdatedAt]": "Ordenar por data de atualização",
  "SelectDateRange": "Intervalo de datas",
  "StartDate": "Data de início",
  "EndDate": "Data de término",
  "Today": "Hoje",
  "Yesterday": "Ontem",
  "ThisWeek": "Esta semana",
  "LastWeek": "Semana passada",
  "Last7Days": "Últimos 7 dias",
  "ThisMonth": "Este mês",
  "LastMonth": "Mês passado",
  "monitoring": "Monitoramento",
  "Haveorder": "Ter pedido",
  "Estimated": "Estimado",
  "ReceiverCash": "Dinheiro (pelo destinatário)",
  "SenderCash": "Dinheiro",
  "SenderWallet": "Carteira",
  "Auto": "Automático",
  "Manual": "Manual",
  "SendOrderr": "Enviar pedido",
  "Neworder": "Novo pedido",
  "Person": "Individual",
  "Business": "comercial",
  "Businessname": "Nome da empresa",
  "phonenumber": "Número de telefone",
  "Adddropoff": "Adicionar entrega",
  "Searchbynameorphonenumber": "Pesquisar por nome ou número de telefone",
  "Fullname": "Nome completo",
  "type": "tipo",
  "only": "xxx apenas",
  "ChooseDriver": "Escolher motorista",
  "AllKey": "Todos",
  "MeKey": "Eu",
  "Vehicletype": "Tipo de veículo",
  "status": "Estado",
  "statusInProgress": "Em andamento",
  "statusCanceled": "Cancelado",
  "statusPending": "Pendente",
  "statusUnassigned": "Não atribuído",
  "statusDone": "Concluído",
  "dispatcher": "operador",
  "customer": "celular",
  "regexcode": "Código",
  "regexcustomerPhone": "Cancelado pelo cliente",
  "regexcustomerName": "Nome do cliente",
  "regexdriverPhone": "Telefone do motorista",
  "regexdriverName": "Nome do motorista",
  "regexdriverUsername": "Nome de usuário do motorista",
  "pickupDescription": "Descrição da coleta",
  "filter": "Filtrar",
  "clear": "Limpar",
  "orderInfoError": "Erro ao receber informações",
  "Details": "Detalhes",
  "History": "Histórico",
  "Phone": "Telefone",
  "km": "km",
  "Espath": "Caminho estimado",
  "Receipt": "Recibo",
  "Copylink": "Copiar link",
  "repeatOrder": "Repetir pedido",
  "Edit": "Editar",
  "EditPrice": "Editar preço",
  "Endtrip": "Concluir pedido",
  "Canceltravel": "Cancelar pedido",
  "CancellText": "Após o cancelamento, o pedido é cancelado para o motorista",
  "confirmCancel": "Sim",
  "Endtravel": "completar",
  "EndlText": "Após a conclusão, o pedido para o cliente e o motorista é concluído com sucesso e o valor é deduzido da conta do cliente",
  "confirmEnd": "Sim",
  "End": "Cancelar pedido",
  "Deliveredat": "Entregue em",
  "pod": "Comprovante de entrega",
  "Notes": "Notas",
  "Nonotes": "Sem notas",
  "Photo": "Foto",
  "Signature": "Assinatura",
  "Nosignature": "Sem assinatura",
  "Nophoto": "Sem foto",
  "ServiceOptions": "Opções de serviço",
  "Events": "Eventos",
  "status2": "status",
  "Creator": "Criador",
  "Creationdate": "Data de criação",
  "Orderid": "ID do pedido",
  "Pickup2": "Coleta",
  "Dropoff2": "Entrega",
  "PleaseSelect": "Por favor, selecione",
  "CreateEvent": "Criar evento",
  "Description": "Descrição",
  "detailsAboutEvent": "Detalhes sobre o evento",
  "CustomerVisibility": "Visibilidade para o cliente",
  "LocationOnMap": "Localização no mapa",
  "Pending": "Pendente",
  "Unassigned": "Não atribuído",
  "Assigned": "Em andamento",
  "PickedUp": "Em andamento",
  "Started": "Em andamento",
  "Done": "Concluído",
  "CustomerCanceled": "Cancelado",
  "DriverCanceled": "Cancelado",
  "SupportCanceled": "Cancelado",
  "Arrived": "Em andamento",
  "Createdsuccessfully": "Criado com sucesso",
  "Estime": "Tempo estimado",
  "Promocode": "Código promocional",
  "Updatedsuccessfully": "Atualizado com sucesso",
  "statusAssigned": "Atribuído",
  "statusStarted": "Iniciado",
  "statusPickedUp": "Iniciado",
  "statusDriverCanceled": "Cancelado pelo motorista",
  "statusArrived": "Chegado",
  "statusSupportCanceled": "Cancelado pelo suporte",
  "Title": "Título",
  "ContactFullname": "Nome completo do contato",
  "Contactphonenumber": "Número de telefone do contato",
  "Commission": "Comissão",
  "surcharge": "Sobretaxa",
  "haslogined": "fez login",
  "Notloggedin": "Não fez login",
  "Schedule": "Agendar",
  "Date": "Data",
  "Time": "Hora",
  "noDateToShow": "Não há data para mostrar",
  "noTimeToShow": "Não há hora para mostrar",
  "Apply": "Aplicar",
  "lowBalance": "saldo baixo",
  "balanceError": "Seu saldo deve ser pelo menos igual ao preço do pedido",
  "Methods": "Métodos",
  "Addressbook": "Catálogo de endereços",
  "AddressbookSearchbar": "Pesquisar por endereço, título e ID",
  "AddressbookDropOf": "Catálogo de endereços (Entrega)",
  "AddressbookPickup": "Catálogo de endereços (Coleta)",
  "hide": "Ocultar",
  "Nosavedaddress": "Nenhum endereço salvo",
  "Romanian": "Romeno",
  "business": "comercial",
  "username": "Nome de Usuário",
  "rememberme": "lembrar de mim",
  "SendOrder": "Enviar pedido",
  "code": "Código",
  "noorder": "semPedido",
  "pleaseSellectParsel": "Por favor, selecione o serviço",
  "Order": "Pedido",
  "Code": "Código",
  "Editorder": "Editar pedido",
  "all": "Todos",
  "Address": "Endereço",
  "Block/Building": "Bloco/Prédio",
  "Pickedupat": "Coletado em",
  "for": "Para",
  "fr": "Francês",
  "AllVehicletypes": "Todos os tipos de serviço",
  "AllServices": "Todos os serviços",
  "French": "Francês",
  "enterDataCorrectly": "Insira as informações corretamente.",
  "controlThatbeforeLoweEqualAfter": "O horário \"\"Antes:\"\" não pode ser menor que \"\"Após:\"\"",
  "ForceAssign": "Atribuição Forçada",
  "Allvehicletypes": "Todos os tipos de veículos",
  "waitforconfirm": "xxx ( Aguarde a confirmação )",
  "waitforconfirm2": "( Aguarde a confirmação )",
  "Dispatching": "Despachando",
  "NoDriver": "Sem motorista",
  "OtherDetails": "Outros detalhes",
  "StatusandDriver": "Status e Motorista",
  "EditStatusandDriver": "Editar Status e Motorista",
  "Current": "Atual",
  "EDAS_Pending": "Pendente",
  "EDAS_Assigned": "Atribuído",
  "EDAS_PickedUp": "Coletado",
  "EDAS_Unassigned": "Não atribuído",
  "EDAS_Started": "Iniciado",
  "EDAS_Done": "Concluído",
  "EDAS_CustomerCanceled": "Cancelado pelo cliente",
  "EDAS_DriverCanceled": "Cancelado pelo motorista",
  "EDAS_SupportCanceled": "Cancelado pelo suporte",
  "EDAS_Arrived": "Chegado",
  "Pleasechooseadrivertochangestatus": "Alterar opções pode afetar o preço",
  "icWarningEdit": "O tipo de veículo será alterado",
  "Vehicletypewillbechanged": "Seu tipo de veículo atual será alterado e afetará o preço",
  "Rejected": "Rejeitado",
  "Rejected2": "(Rejeitado)",
  "DriverVehicleTypeError": "Não há tipo de veículo para o motorista",
  "CodeNameFamilyPhonenumber": "Código, Nome, Família, Número de telefone",
  "youcanselectdriverintheedit": "Você pode selecionar o motorista ao editar motorista e status",
  "Earning": "Ganho",
  "savePrice": "Salvar Preço",
  "saveEarning": "Salvar Ganho",
  "Total": "Total",
  "EditPickupDropOff": "Endereços",
  "noMoreData": "Não há mais informações",
  "OnDemand": "Sob demanda",
  "PD": "P & D",
  "PD2": "P&D",
  "PickupDropoff": "Coleta, Entrega",
  "PickupFlag": "C",
  "DropOffFlag": "E",
  "PickupandDelivery": "Coleta e entrega",
  "PickupDelivery": "Coleta e entrega",
  "Delivery": "Entrega",
  "Collecting": "Coletando",
  "Transit": "Trânsito",
  "Delivering": "Entregando",
  "EDAS_Collecting": "Coletando",
  "EDAS_Transit": "Trânsito",
  "EDAS_Delivering": "Entregando",
  "statusCollecting": "Coletando",
  "statusTransit": "Trânsito",
  "statusDelivering": "Entregando",
  "serviceCustomerError1": "xxx não está disponível para este cliente.",
  "serviceCustomerError2": "Ele/ela só pode escolher o serviço xxx",
  "serviceCustomerError3": "Ele/ela só pode escolher xxx",
  "OrderCode": "Código do Pedido",
  "event_Created": "Criado",
  "event_Unassigned": "Não atribuído",
  "event_Assigned": "Atribuído",
  "event_Started": "Iniciado",
  "event_Arrived": "Chegado",
  "event_PickedUp": "Coletado",
  "event_OrderDone": "Pedido Concluído",
  "event_DropoffDone": "Entrega Concluída",
  "event_CustomerFeedback": "Feedback do Cliente",
  "event_AddPod": "Adicionar Pod",
  "event_CustomerCanceled": "Cancelado pelo cliente",
  "event_DriverCanceled": "Cancelado pelo motorista",
  "event_SupportCanceled": "Cancelado pelo suporte",
  "event_Updated": "Atualizado",
  "event_DriverAssignment": "Atribuição de Motorista",
  "event_DriverReject": "Recusa do Motorista",
  "event_Collecting": "Coletando",
  "event_InTransit": "Em trânsito",
  "event_Delivering": "Entregando",
  "event": "Evento",
  "tab_Delivery": "Entrega",
  "tab_Ondemand": "Sob demanda",
  "tab_Pickup": "Coleta",
  "tab_PickupDelivery": "P&D",
  "CurrentStatus": "Status Atual",
  "Changestatus": "Alterar status",
  "Newstatus": "Novo status",
  "Savechanges": "Salvar alterações",
  "Other": "Outro",
  "Shipmentlabel": "Etiqueta de envio",
  "pleaseSellectService": "Por favor, selecione o tipo de serviço",
  "EditPrice2": "Preço",
  "EditEarning": "Ganho",
  "statusCustomerCanceled": "Cancelado pelo cliente",
  "Yourcurrentvehicletypeanditwillbechangedandeffectsonprice": "Seu tipo de veículo atual será alterado e afetará o preço",
  "Dutch": "holandês",
  "Ondemand": "Sob demanda",
  "todayat": "Hoje às",
  "tomorrowat": "Amanhã às",
  "nextWeekat": "Na próxima semana às",
  "lastDayat": "No dia seguinte às",
  "lastWeekat": "Semana passada às",
  "CopyOrderlink": "Copiar link do pedido",
  "CopyPickuplink": "Copiar link da coleta",
  "CopyDeliverylink": "Copiar link da entrega",
  "Bulkimport": "Importação em massa",
  "Downloadsamplecsv": "Baixar CSV de exemplo",
  "processing": "Processando",
  "done": "Concluído",
  "failed": "Falhou",
  "Draft": "Rascunho",
  "Uploading": "Carregando",
  "Draganddropyourfile": "Arraste e solte seu arquivo",
  "Onlycsvformatissupported": "Apenas o formato .csv é suportado",
  "ORyoucan": "Ou você pode",
  "Openfile": "Abrir arquivo",
  "Noimportsyet": "Ainda não há importações",
  "NoimportsyetDesc": "Você pode ver a lista de suas importações aqui e verificar seu status",
  "nosupportdialogeTitle": "Formato de arquivo não suportado",
  "nosupportdialogeText": "Arquivo xxx não é suportado. você só pode carregar arquivo .csv com informações do pedido",
  "ok": "ok",
  "Import": "Importar",
  "previewTitle": "Visualizar e escolher opções",
  "previewDesc": "Este é o primeiro item de seus arquivos para verificar se suas informações estão na estrutura correta",
  "Upload": "Carregar",
  "Remove": "Remover",
  "ServiceandOrdertype": "Tipo de Serviço e Pedido",
  "Fileisproccessing": "Arquivo está sendo processado...",
  "proccessingDesc": "Você pode atualizar para ver se o resultado está pronto",
  "serverError": "Erro do servidor",
  "isRequired": "xxx é obrigatório",
  "Result": "Resultado",
  "ResultText": "Você pode ver os problemas aqui e baixar essas linhas para corrigir separadamente",
  "ErrorDetails": "Pedidos com erro",
  "ErrorDetailsText": "Pedidos com erros estão listados no arquivo que você pode baixar abaixo. Ele contém detalhes dos erros para cada linha.",
  "DownloadErroredRows": "Baixar linhas com erro",
  "importedsuccessfully": "xxx pedidos foram importados com sucesso",
  "ordershaserrors": "xxx pedidos têm erros",
  "refresh": "Atualizar",
  "CashOnDelivery": "Pagamento na entrega",
  "EnterAmount": "Insira o valor",
  "COD": "Pagamento na entrega",
  "Surchargexxx": "Sobretaxa xxx",
  "AddCreditCard": "Adicionar Cartão de Crédito/Débito",
  "CustomerWallet": "Carteira do Cliente",
  "Add": "Adicionar",
  "Addedsuccessfully": "Adicionado com sucesso",
  "NoRecentAddress": "Nenhum endereço recente",
  "NoRecentAddressD": "Endereços recentes do cliente serão listados aqui",
  "CustomerIsNotChoosed": "Cliente não selecionado",
  "CustomerIsNotChoosedD": "Escolha o cliente para mostrar o endereço recente",
  "SearchAddress": "Buscar endereço",
  "NoCustomerfound": "Nenhum cliente encontrado",
  "NoCustomerfoundD": "Você pode criar um novo cliente",
  "NewCustomer": "Novo Cliente",
  "Existing": "Existente",
  "EmailOtional": "E-mail (Opcional)",
  "phonenumberisnotcorrect": "Número de telefone incorreto",
  "Emailisnotcorrect": "E-mail incorreto",
  "Registercustomer": "Registrar cliente",
  "incoming": "Chamada de entrada",
  "outgoing": "Chamada de saída",
  "recording": "Gravando chamada",
  "driveroperatorCallStatus": "Motorista chamou operador",
  "customeroperatorCallStatus": "Cliente chamou operador",
  "newCustomeroperatorCallStatus": "Novo cliente chamou operador",
  "operatordriverCallStatus": "Operador chamou motorista",
  "operatorcustomerCallStatus": "Operador chamou cliente",
  "operatornewCustomerCallStatus": "Operador chamou novo cliente",
  "dispatcher_Voip": "Operador",
  "driver_Voip": "Motorista",
  "customer_Voip": "Cliente",
  "activeorders": "xxx pedidos ativos",
  "Noactiveorder": "Nenhum pedido ativo ",
  "CreateOrder": "Criar Pedido",
  "call": "Chamada",
  "spanish": "Espanhol",
  "es": "Espanhol",
  "networkError": "Sem conexão com a Internet",
  "germany": "Alemanha",
  "de": "Alemão",
  "Itisnotpossibletorepeattherequest": "Não é possível repetir o pedido",
  "createdAt": "Criado em",
  "dueDate": "Data de vencimento",
  "Noresultfound": "Nenhum resultado encontrado",
  "loadMore": "Carregar mais",
  "Searchresult": "Resultado da busca",
  "AssignedAt": "Atribuir até xxx",
  "StartedAt": "Iniciar até xxx",
  "ArrivedAt": "Chegar até xxx",
  "PickedUpAt": "Retirar em xxx",
  "DoneAt": "Concluir em xxx",
  "mindelay": "Atraso de xxxm",
  "minlate": "xxxm de atraso",
  "PinTop": "Fixar no topo",
  "UnPin": "Desfixar",
  "Itemsonmap": "Itens no mapa",
  "min": "xxx min",
  "Confirming": "Confirmando",
  "delay": "Atraso",
  "late": "Atrasado",
  "OrderDetails": "Detalhes do pedido",
  "Profile": "Perfil",
  "Waitingforavailabledrivers": "Aguardando motoristas ficarem disponíveis",
  "Queue": "Fila",
  "OfferingToDrivers": "Oferecendo para xxx motoristas",
  "WaitforAccept": "Aguardar aceitação",
  "Thereisnoorder": "Não há pedido",
  "mapitems": "Itens do mapa",
  "Offerings": "Ofertas",
  "Reject": "Rejeitar",
  "dropoffCustomerDescription": "Nota de entrega",
  "customerPhoto": "Foto do cliente",
  "driverPhoto": "Foto do motorista",
  "NocustomerPhoto": "Sem foto do cliente",
  "NodriverPhoto": "Sem foto do motorista",
  "initial": "inicial",
  "notifying": "notificando",
  "received": "recebido",
  "assigned": "atribuído",
  "rejected": "rejeitado",
  "canceled": "cancelado",
  "standby": "em espera",
  "terminated": "terminado",
  "urgentTitle": "Mudar para Despacho Urgente?",
  "urgentDesc": "Ao ativar urgente, o pedido terá prioridade máxima para despacho",
  "urgentConfirm": "Sim, Ativar Urgente",
  "urgentClose": "Não, Cancelar",
  "Urgent": "Urgente",
  "photos": "Fotos",
  "Portuguese": "Português",
  "Dispatchat": "Despachar em xxx",
  "AutoDispatch": "Despacho Automático",
  "Dispatchtime": "Tempo de despacho",
  "Later": "Depois",
  "DispatchingNow": "Despachando Agora",
  "NoResultfromLocalDatabase": "Nenhum resultado do banco de dados local",
  "NoResultfromLocalDatabaseD": "Verifique novamente ou tente outra palavra-chave",
  "NoResultfromMapService": "Nenhum resultado do serviço de mapas",
  "now": "Agora",
  "ascending": "Ascendente",
  "descending": "Descendente",
  "Last3Month": "Últimos 3 Meses",
  "Pickupnote": "Nota de retirada",
  "pop": "Comprovante de retirada",
  "Required": "Obrigatório",
  "SearchinMapService": "Buscar no Serviço de Mapas",
  "SearchinLocalDatabase": "Buscar no Banco de Dados Local",
  "Creditcardnotadded": "Cartão de crédito não adicionado",
  "OptimizeDropoffs": "Otimizar Entregas",
  "Greek": "Grego",
  "el": "Grego",
  "ReferenceID": "ID de Referência",
  "EnterId": "Digite o id",
  "German": "Alemão",
  "AustrianGerman": "Alemão Austríaco",
  "EDAS_PickupFailed": "Falha na Retirada",
  "EDAS_Lost": "Perdido",
  "EDAS_Returned": "Devolvido",
  "EDAS_Draft": "Rascunho",
  "EDAS_Confirmed": "Confirmado",
  "EDAS_PickupRouted": "RetiradaRoteada",
  "EDAS_ReadyForPickup": "ProntoParaRetirada",
  "EDAS_AtWarehouse": "NoArmazém",
  "EDAS_DeliveryRouted": "EntregaRoteada",
  "EDAS_ReadyForDelivery": "ProntoParaEntrega",
  "EDAS_OutForDelivery": "SaiuParaEntrega",
  "EDAS_Delivered": "Entregue",
  "EDAS_NotDelivered": "NãoEntregue",
  "EDAS_ForReturn": "ParaDevolução",
  "Options": "Opções",
  "VehicleOptions": "Opções de Veículo",
  "EditCustomer": "Editar Cliente",
  "NoDriverfound": "Nenhum motorista encontrado",
  "NoDriverfoundDesc": "Verifique suas informações e tente outra coisa",
  "ClearField": "Limpar Campo",
  "Map": "Mapa",
  "Local": "Local",
  "CompleteRequiredFeileds": "Preencha os Campos Obrigatórios",
  "Senderinfo": "Informações do remetente",
  "Receiverinfo": "Informações do destinatário",
  "SchedulePickup(Optional)": "Agendar Retirada (Opcional)",
  "ScheduleDelivery(Optional)": "Agendar Entrega (Opcional)",
  "AddDropoff": "Adicionar Entrega",
  "Promotion": "Promoção",
  "tax": "Imposto",
  "Shipmentlabeldownloaded": "Etiqueta de envio baixada",
  "statusDraft": "Rascunho",
  "statusConfirmed": "Confirmado",
  "statusPickupRouted": "RetiradaRoteada",
  "statusReadyForPickup": "ProntoParaRetirada",
  "statusAtWarehouse": "NoArmazém",
  "statusDeliveryRouted": "EntregaRoteada",
  "statusReadyForDelivery": "ProntoParaEntrega",
  "statusOutForDelivery": "SaiuParaEntrega",
  "statusDelivered": "Entregue",
  "statusNotDelivered": "NãoEntregue",
  "statusForReturn": "ParaDevolução",
  "statusReturned": "Devolvido",
  "statusPickupFailed": "Falha na Retirada",
  "statusLost": "Perdido",
  "event_Draft": "Rascunho",
  "event_Confirmed": "Confirmado",
  "event_PickupRouted": "RetiradaRoteada",
  "event_ReadyForPickup": "ProntoParaRetirada",
  "event_AtWarehouse": "NoArmazém",
  "event_DeliveryRouted": "EntregaRoteada",
  "event_ReadyForDelivery": "ProntoParaEntrega",
  "event_OutForDelivery": "SaiuParaEntrega",
  "event_Delivered": "Entregue",
  "event_NotDelivered": "NãoEntregue",
  "event_ForReturn": "ParaDevolução",
  "event_Returned": "Devolvido",
  "event_PickupFailed": "Falha na Retirada",
  "event_Lost": "Perdido",
  "event_IncomingCall": "ChamadaDeEntrada",
  "event_OutgoingCall": "ChamadaDeSaída",
  "event_DispatchOrder": "DespacharPedido",
  "tryagain": "Algo deu errado, por favor tente novamente",
  "Selected date and time": "Data e hora selecionadas",
  "Reorder stops": "Reordenar paradas",
  "Bulk Edit Status Summary": "Resumo da Edição em Massa",
  "Successful": "Bem-sucedido",
  "Failed": "Falhou",
  "Order ID": "ID do Pedido",
  "Pickup Routed": "Retirada Roteada",
  "Delivery Routed": "Entrega Roteada",
  "Ref. xxx": "Ref. xxx",
  "Zone": "Zona",
  "Clear": "Limpar",
  "No result found": "Nenhum resultado encontrado",
  "Type your keyword": "Digite sua palavra-chave",
  "Type in the input to start search": "Digite na entrada para iniciar a busca",
  "We are sorry ...": "Lamentamos ...",
  "The page you are trying to access has restricted access.": "A página que você está tentando acessar tem acesso restrito.",
  "Please refer to your system administrator.": "Por favor, consulte o administrador do sistema.",
  "Proof of delivery": "Comprovante de entrega",
  "Driver Photo": "Foto do motorista",
  "Order Info": "Informações do Pedido",
  "P_HUB_D Orders": "Pedidos P_HUB_D",
  "Routes": "Rotas",
  "Default pickup": "Retirada padrão",
  "More": "Mais",
  "Route name": "Nome da rota",
  "Driver": "Motorista",
  "Pickup Orders": "Pedidos de Retirada",
  "Delivery Orders": "Pedidos de Entrega",
  "Ready For Pickup": "Pronto Para Retirada",
  "PricingAndEarning": "Preços e Ganhos",
  "Pricing": "Preços",
  "save": "Salvar",
  "Learn": "Aprender",
  "Scheduleoverlap": "O horário de Retirada deve ser antes do horário de Entrega e não pode haver sobreposição",
  "PleaseSelectCustomer": "Por favor, selecione o cliente",
  "NoRegisteredCustomer": "Nenhum cliente registrado",
  "CreateAtLeastOneCustomerToCreateOrder": "Crie pelo menos um cliente para criar pedido",
  "Pinned": "Fixado",
  "Delayed": "Atrasado",
  "Canceled": "Cancelado",
  "InProgress": "EmProgresso",
  "DispatchLater": "DespacharDepois",
  "Table": "Tabela",
  "Clear All": "Limpar Tudo",
  "Config Table": "Configurar Tabela",
  "Active Columns": "Colunas Ativas",
  "Due time": "Prazo",
  "Search route name": "Buscar nome da rota",
  "Add Route": "Adicionar Rota",
  "Route info": "Informações da Rota",
  "Start Location": "Local de Início",
  "End Location ( Optional )": "Local de Término (Opcional)",
  "Load Deliveries:": "Carregar Entregas:",
  "No": "Não",
  "Optional": "Opcional",
  "Force": "Forçar",
  "Code, Name, Family, Phone number": "Código, Nome, Família, Número de telefone",
  "Edit Route Status & Driver": "Editar Status da Rota e Motorista",
  "No, Cancel": "Não, Cancelar",
  "Yes, Optimize": "Sim, Otimizar",
  "Optimize Stops?": "Otimizar Paradas?",
  "The sequence of stops changes automatically. you can change it manually later": "A sequência de paradas é alterada automaticamente. você pode alterá-la manualmente mais tarde",
  "Error in loading data": "Erro ao carregar dados",
  "There was a problem loading data. please try again or contact support": "Houve um problema ao carregar dados. por favor, tente novamente ou entre em contato com o suporte",
  "Try again": "Tente novamente",
  "Duration:": "Duração:",
  "Edit Route info": "Editar informações da Rota",
  "Edit Status & Driver": "Editar Status e Motorista",
  "Reorder Stops": "Reordenar Paradas",
  "Optimize": "Otimizar",
  "Search stops": "Buscar paradas",
  "Delivery:": "Entrega:",
  "Pickup:": "Retirada:",
  "No Stop was found": "Nenhuma parada encontrada",
  "Please check it again or try another keyword": "Verifique novamente ou tente outra palavra-chave",
  "Add your orders": "Adicione seus pedidos",
  "You can add orders from orders pages": "Você pode adicionar pedidos das páginas de pedidos",
  "Go to Orders": "Ir para Pedidos",
  "On Demand": "Sob Demanda",
  "P_Hub_D": "P_Hub_D",
  "Notifications": "Notificações",
  "Admin Center": "Centro Administrativo",
  "Sort by": "Ordenar por",
  "Sort type": "Tipo de ordenação",
  "OrderType": "Tipo de Pedido",
  "Stage": "Fase",
  "Status": "Status",
  "Route": "Rota",
  "CreatedAt": "CriadoEm",
  "StatusUpdatedAt": "StatusAtualizadoEm",
  "Note": "Nota",
  "Delivery Last Attempt Reason": "Motivo da Última Tentativa de Entrega",
  "Delivery Attempts Count": "Contagem de Tentativas de Entrega",
  "Pickup Failed Reason": "Motivo da Falha na Retirada",
  "ReferenceId": "IdReferência",
  "PickupAddress": "Endereço de Retirada",
  "DeliveryAddress": "Endereço de Entrega",
  "Driver Name": "Nome do Motorista",
  "Driver Phone": "Telefone do Motorista",
  "Customer Name": "Nome do Cliente",
  "Customer Phone": "Telefone do Cliente",
  "EstimatedDistanceInMeters": "DistânciaEstimadaEmMetros",
  "EstimatedDuration": "DuraçãoEstimada",
  "Payment Method": "Método de Pagamento",
  "PickupAddressDetail": "Detalhes do Endereço de Retirada",
  "PickupCompleteAfter": "RetiradaConcluídaApós",
  "PickupcompleteBefore": "RetiradaConcluídaAntes",
  "PickupFullName": "NomeCompletoRetirada",
  "PickupPhone": "TelefoneRetirada",
  "PickupEmail": "EmailRetirada",
  "PickupPodNote": "NotaPodRetirada",
  "PickupPodPhoto": "FotoPodRetirada",
  "PickupPodSignature": "AssinaturaPodRetirada",
  "PickupZone": "ZonaRetirada",
  "DeliveryAddressDetail": "Detalhes do Endereço de Entrega",
  "DeliveryCompleteAfter": "EntregaConcluídaApós",
  "DeliverycompleteBefore": "EntregaConcluídaAntes",
  "DeliveryFullName": "NomeCompletoEntrega",
  "DeliveryPhone": "TelefoneEntrega",
  "DeliveryEmail": "EmailEntrega",
  "DeliveryPodNote": "NotaPodEntrega",
  "DeliveryPodPhoto": "FotoPodEntrega",
  "DeliveryPodSignature": "AssinaturaPodEntrega",
  "DeliveryZone": "ZonaEntrega",
  "Driver Vehicle": "Veículo do Motorista",
  "Driver Username": "Nome de Usuário do Motorista",
  "CustomerType": "Tipo de Cliente",
  "Customer Email": "Email do Cliente",
  "PaymentProvider": "Provedor de Pagamento",
  "Source": "Fonte",
  "Shipment Label": "Etiqueta de Envio",
  "Track Order": "Rastrear Pedido",
  "Create your first order": "Crie seu primeiro pedido",
  "Your orders will be shown here in table with full details and actions": "Seus pedidos serão exibidos aqui em tabela com todos os detalhes e ações",
  "Please check your filters or keyword": "Por favor, verifique seus filtros ou palavra-chave",
  "from": "de",
  "rows": "linhas",
  "Prev": "Anterior",
  "Next": "Próximo",
  "Stages": "Fases",
  "RouteName": "NomeDaRota",
  "Services": "Serviços",
  "PaymentSides": "LadosDoPagamento",
  "pickupzones": "zonasderetirada",
  "deliveryzones": "zonasdeentrega",
  "Zones": "Zonas",
  "CodAmount": "ValorCod",
  "Payment Methods": "Métodos de Pagamento",
  "Delivery Attempt Number": "Número de Tentativas de Entrega",
  "paymentMethods": "métodosdepagamento",
  "Edit Status": "Editar Status",
  "Select Status": "Selecionar Status",
  "Select Reason": "Selecionar Motivo",
  "Select Route": "Selecionar Rota",
  "Don’t change routes": "Não mudar rotas",
  "Edit routes": "Editar rotas",
  "Remove routes": "Remover rotas",
  "You must assign driver to select this route": "Você deve atribuir um motorista para selecionar esta rota",
  "You must choose an unassigned route or unassign selected route": "Você deve escolher uma rota não atribuída ou desatribuir a rota selecionada",
  "Create P_HUB_D Only order": "Criar pedido P_HUB_D",
  "Add routes": "Adicionar rotas",
  "Your routes will be shown here in": "Suas rotas serão exibidas aqui em",
  "Add orders": "Adicionar pedidos",
  "Bulk select in orders list and add orders with edit status button": "Seleção em massa na lista de pedidos e adicione pedidos com botão de editar status",
  "Create Ondemand order": "Criar pedido Sob Demanda",
  "Your orders will be shown here in list": "Seus pedidos serão exibidos aqui em lista",
  "Create Pickup Only order": "Criar pedido Apenas Retirada",
  "Create Delivery Only order": "Criar pedido Apenas Entrega",
  "No offline driver": "Nenhum motorista offline",
  "Offline drivers will be shown here": "Motoristas offline serão exibidos aqui",
  "No online driver": "Nenhum motorista online",
  "Online drivers will be shown here": "Motoristas online serão exibidos aqui",
  "Driver login info": "Informações de login do motorista",
  "Driver must be online in the app to see it here  and be able to assign orders": "O motorista deve estar online no aplicativo para ver aqui e poder atribuir pedidos",
  "Scan to Download Driver app": "Escaneie para baixar o aplicativo do motorista",
  "OR": "OU",
  "Open the link in your phone": "Abra o link no seu telefone",
  "Copy link to clipboard": "Copiar link para área de transferência",
  "Copied!": "Copiado!",
  "Add drivers": "Adicionar motoristas",
  "Pleaseselectroutefromsearchresults": "Por favor, selecione a rota nos resultados da busca",
  "Addroutestobeabletosearchandselectroute": "Adicione rotas para poder buscar e selecionar a rota",
  "NoRoutes": "Sem Rotas",
  "Searchandselectroute": "Buscar e selecionar rota",
  "EDROPANDDE2": "Somente rotas não atribuídas são permitidas para este status",
  "EDROPANDDE1": "Somente rotas atribuídas ou iniciadas são permitidas para este status",
  "Help center": "Central de Ajuda",
  "selected": "selecionado",
  "Add your driver in admin center": "Adicione seu motorista no centro administrativo",
  "Demo tip": "Dica de demonstração",
  "Change password": "Mudar senha",
  "Enter your new password": "Digite sua nova senha",
  "Password must be at least 6 characters": "A senha deve ter pelo menos 6 caracteres",
  "Repeat password doesn’t match": "A repetição da senha não coincide",
  "Password changed": "Senha alterada",
  "Return to app and login again": "Retorne ao aplicativo e faça login novamente",
  "Collection from": "Coleta de",
  "Search and select address": "Buscar e selecionar endereço",
  "Deliver to": "Entregar em",
  "SchedulePickup": "Agendar Retirada",
  "ScheduleDelivery": "Agendar Entrega",
  "Walletbalanceislow": "Saldo da carteira está baixo",
  "Walletbalanceislowd": "Para usar a carteira, seu saldo deve ser pelo menos igual ao preço do pedido.",
  "refid_tooltip": "\"\"Use para adicionar um ID interno para identificar a entrega. Isso também será exibido nas faturas e para os transportadores, se necessário\"\"",
  "DeliveryMethod": "Método de Entrega",
  "Search and select service point": "Buscar e selecionar ponto de serviço",
  "Add service points in admin center": "Adicionar pontos de serviço no centro administrativo",
  "No service point available": "Nenhum ponto de serviço disponível",
  "Add service point": "Adicionar ponto de serviço",
  "All Service points": "Todos os Pontos de Serviço",
  "Service point": "Ponto de Serviço",
  "statusAtPickupServicePoint": "NoPontoDeServiçoDeRetirada",
  "statusAtDeliveryServicePoint": "NoPontoDeServiçoDeEntrega",
  "EDAS_AtDeliveryServicePoint": "NoPontoDeServiçoDeEntrega",
  "EDAS_AtPickupServicePoint": "NoPontoDeServiçoDeRetirada",
  "Preview": "Visualizar",
  "LoadDeliveries": "Carregar Entregas:",
  "Start time": "Hora de Início",
  "Tomorrow": "Amanhã",
  "Started at": "Iniciado em",
  "Finish at": "Concluir em",
  "Active route": "Rota ativa",
  "done at": "Concluído em",
  "Failed at": "Falhou em",
  "chat": "Bate-papo",
  "No message": "Sem mensagem",
  "Message between customer and driver will be show here": "A mensagem entre o cliente e o motorista será exibida aqui",
  "Clear Selection": "Limpar Seleção",
  "pickup": "Coleta",
  "delivery": "Entrega",
  "Select pins": "Selecionar pinos",
  "Order Stops": "Ordenar Paradas",
  "Free": "Livre",
  "Busy": "Ocupado",
  "Reset": "Redefinir",
  "None": "Nenhum",
  "Please check your keyword": "Por favor, verifique sua palavra-chave",
  "Clear search": "Limpar busca",
  "Delayxmin": "Atraso xxx",
  "Latexmin": "Tarde xxx",
  "AssignedIn": "Atribuir em xxx",
  "StartedIn": "Iniciar em xxx",
  "ArrivedIn": "Chegar em xxx",
  "PickedUpIn": "Coleta em xxx",
  "DoneIn": "Concluir em xxx",
  "Assign": "Atribuir",
  "On": "LIGADO",
  "Off": "DESLIGADO",
  "activeOrdersCount": "Número de pedidos",
  "No Orders": "Sem Pedidos",
  "No drivers found": "Nenhum motorista encontrado",
  "Your Free Trial Has Ended": "Seu Período de Teste Gratuito Terminou",
  "To extend your trial or subscribe with Onro, please use one of the direct options below to connect with us.": "Para estender seu teste ou assinar com a Onro, use uma das opções diretas abaixo para entrar em contato conosco.",
  "Book a meeting": "Agendar uma reunião",
  "WhatsApp: +37066515455": "WhatsApp: +37066515455",
  "Email: mosayeb@onro.io": "Email: mosayeb@onro.io",
  "Account Suspended": "Conta Suspensa",
  "Your account has been suspended due to unpaid invoices. To reactivate your account, please complete your payment using below options.": "Sua conta foi suspensa devido a faturas não pagas. Para reativar sua conta, complete seu pagamento usando as opções abaixo.",
  "Pay Now with payment link": "Pague Agora com link de pagamento",
  "PickupPopNote": "PickupPopNote",
  "PickupPopPhoto": "PickupPopPhoto",
  "PickupPopSignature": "PickupPopSignature",
  "xxxaway": "xxx distante",
  "Order type": "Tipo de pedido",
  "Select": "Selecionar",
  "Fields": "Campos",
  "Ref ID": "Ref ID",
  "Custom": "Personalizado",
  "Customerinfo": "Informações do cliente",
  "Driverinfo": "Informações do motorista",
  "Vehicle": "Veículo",
  "Plate": "Placa",
  "Vehicletyps": "Tipos de veículo",
  "customrequired": "Este campo é obrigatório",
  "custominvalid": "Valor inválido",
  "custompattern": "Formato inválido",
  "customminLength": "Mínimo de {{min}} caracteres exigidos",
  "custommaxLength": "Máximo de {{max}} caracteres permitidos",
  "customemail": "Endereço de email inválido",
  "customphone": "Número de telefone inválido",
  "customnumber": "O valor deve ser um número",
  "customnumberMin": "O valor mínimo permitido é {{min}}",
  "customnumberMax": "O valor máximo permitido é {{max}}",
  "customdecimalPrecision": "Máximo de {{p}} casas decimais permitido",
  "customselect": "Seleção inválida",
  "customfileInvalid": "Arquivo inválido",
  "customfileSize": "O tamanho máximo do arquivo é {{max}} MB",
  "customfileType": "Tipo de arquivo não permitido",
  "customdate": "Data inválida",
  "customdateTime": "Data e hora inválidas",
  "customjson": "Formato JSON inválido",
  "addressDetail": "Detalhe do Endereço",
  "Override ETA": "Substituir ETA",
  "Enter in mintues": "Digite em minutos",
  "Home message": "Mensagem inicial",
  "Enter Text": "Digite o Texto",
  "addressservice-point": "Door -> Service point",
  "service-pointservice-point": "Service point -> Service point",
  "addressaddress": "Door -> Door",
  "service-pointaddress": "Service point -> Door",
  "Time slot":"Janela de horário",
  "ASAP":"O mais rápido possível",
    "SchedulePickup": "Agendar Retirada",
  "ScheduleDelivery": "Agendar Entrega",
      "Schedulepickup": "Agendar Retirada",
    "Scheduledelivery": "Agendar Entrega",
  "Your account has been suspended due to unpaid invoices. To reactivate your account, please complete your payment using below options.": "Your account has been suspended due to unpaid invoices. To reactivate your account, please complete your payment using below options."
}
